const YELLOW = "#FFC700";
export const ORANGE = "#FF900A";
const ORANGE_SODA = "#FB492C";
const RED = "#F6024E";
const BYZANTINE = "#C837A5";
const MEDIUM_PURPLE = "#996CFB";
const ORCHID = "#B152D0";
const VIOLET_COLOR_WHEEL = "#6F3AF6";
const HAN_PURPLE = "#5A21F3";
const PERSIAN_INDIGO = "#3F148C";
export const PURPLE = PERSIAN_INDIGO;
export const INACTIVE = "#CCCCCC";
export const COLORS_4 = [ORANGE, RED, MEDIUM_PURPLE, HAN_PURPLE];

const COLORS_10 = [
  YELLOW,
  ORANGE,
  ORANGE_SODA,
  RED,
  BYZANTINE,
  ORCHID,
  MEDIUM_PURPLE,
  VIOLET_COLOR_WHEEL,
  HAN_PURPLE,
  PERSIAN_INDIGO,
];

export const COLORS_9 = [
  ORANGE,
  ORANGE_SODA,
  RED,
  BYZANTINE,
  ORCHID,
  MEDIUM_PURPLE,
  VIOLET_COLOR_WHEEL,
  HAN_PURPLE,
  PERSIAN_INDIGO,
];

const COLORS_8 = [
  YELLOW,
  ORANGE,
  RED,
  BYZANTINE,
  ORCHID,
  MEDIUM_PURPLE,
  HAN_PURPLE,
  PERSIAN_INDIGO,
];

const COLORS_8_NO_YELLOW = [
  ORANGE,
  RED,
  BYZANTINE,
  ORCHID,
  MEDIUM_PURPLE,
  VIOLET_COLOR_WHEEL,
  HAN_PURPLE,
  PERSIAN_INDIGO,
];

const COLORS_7 = [
  YELLOW,
  ORANGE,
  RED,
  BYZANTINE,
  MEDIUM_PURPLE,
  HAN_PURPLE,
  PERSIAN_INDIGO,
];

const COLORS_7_NO_YELLOW = [
  ORANGE,
  RED,
  BYZANTINE,
  ORCHID,
  MEDIUM_PURPLE,
  HAN_PURPLE,
  PERSIAN_INDIGO,
];

const COLORS_6 = [
  ORANGE,
  RED,
  BYZANTINE,
  MEDIUM_PURPLE,
  HAN_PURPLE,
  PERSIAN_INDIGO,
];

const COLORS_5 = [ORANGE, RED, BYZANTINE, VIOLET_COLOR_WHEEL, PERSIAN_INDIGO];

export const COLOR_MAP = {
  5: COLORS_5,
  6: COLORS_6,
  7: COLORS_7,
  8: COLORS_8,
  9: COLORS_9,
  10: COLORS_10,
};

export const COLOR_MAP_NO_YELLOW = {
  5: COLORS_5,
  6: COLORS_6,
  7: COLORS_7_NO_YELLOW,
  8: COLORS_8_NO_YELLOW,
  9: COLORS_9,
};
